const { requestManager } = require('../../requestManager');

const { API_PATH } = require('../../config/config');

class RsvDocMastaApi {
  /**
   * 予約規約文書マスタ取得
   * @param {string} lgCd 市町村コード
   * @return {Promise<Array>} 予約規約文書マスタ
   */
  getRsvDoc = async (lgCd) => {
    const params = { lgCd };
    const result = await requestManager.get(`${API_PATH}/masta/rsvDoc/r`, params);
    return result.data;
  };
}

export default new RsvDocMastaApi();
